import { configService } from "@/settings/api-url";
const actions = {
  async action_getQuestionOrder({ commit }) {
    try {
      const res = await configService("normal_user/questions?purpose=2");
      commit("QUESTION_ORDER", res.data);
      return res;
    } catch (error) {
      return error.response;
    }
  },
  async action_getAnswers({ commit, rootState }) {
    try {
      const res = await configService(`/orders/${rootState.orders.currentOrder.id}/order_ratings`);
      let answers = res.data.map((element) => {
        return { type: element.question.question, answer: element.answer };
      });
      commit("ANSWERS", answers);
      return res;
    } catch (error) {
      return error.response;
    }
  },
  async action_postAnswers({ dispatch, rootState }, data) {
    try {
      const res = await configService(`/orders/${rootState.orders.currentOrder.id}/order_ratings`, {
        method: "POST",
        data,
      });
      dispatch("action_getAnswers");
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

export default actions;
